var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTransactionWithdraw = function SvgIconTransactionWithdraw(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#777E90",
    d: "M15.417 18.125H4.583a1.466 1.466 0 0 1-1.458-1.458V5a.633.633 0 0 1 .625-.625h12.5a.634.634 0 0 1 .625.625v11.667a1.466 1.466 0 0 1-1.458 1.458M4.375 5.625v11.042a.21.21 0 0 0 .208.208h10.834a.21.21 0 0 0 .208-.208V5.625z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#777E90",
    d: "M10 14.44a1.46 1.46 0 0 1-1.033-.426l-1.909-1.908a.625.625 0 0 1 .884-.884l1.908 1.909a.21.21 0 0 0 .3 0l1.908-1.909a.625.625 0 0 1 .884.884l-1.909 1.908A1.46 1.46 0 0 1 10 14.44"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#777E90",
    d: "M10 14.794a.633.633 0 0 1-.625-.625V8.336a.625.625 0 0 1 1.25 0v5.833a.633.633 0 0 1-.625.625"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#777E90",
    d: "M18.333 9.792a.634.634 0 0 1-.625-.625V3.333a.21.21 0 0 0-.209-.208h-15a.21.21 0 0 0-.208.208v5.834a.625.625 0 0 1-1.25 0V3.333a1.467 1.467 0 0 1 1.458-1.458h15a1.467 1.467 0 0 1 1.459 1.458v5.834a.633.633 0 0 1-.625.625"
  })));
};
export default SvgIconTransactionWithdraw;